<div class="container">
  <div class="logo b2a">
    <img class="image" src="/assets/logos/4C_Logo_B2A_Claim2018.svg" alt="Back2Action">
    <p class="subline" >{{'LOGIN.logosubline' |translate}}</p>
  </div>

  <app-module>
    <div [@tab] *ngIf="!resetFormIsOpen">
      <form class="login-container" [formGroup]="loginForm" (ngSubmit)="login($event)">
        <app-introtext>
          <h1>{{'LOGIN.header' |translate}}</h1>
          <p>{{'LOGIN.subheader' |translate}}</p>
        </app-introtext>

        <app-input>
          {{'LOGIN.labelEmail' |translate}}
          <input #inputEmail type="email" [formControlName]="'email'" placeholder="{{'LOGIN.placeholderEmail' |translate}}">
        </app-input>
        <app-input>
          {{'LOGIN.labelPassword' |translate}}
          <input #inputPwd type="password" [formControlName]="'password'" placeholder="{{'LOGIN.placeholderPassword' |translate}}">
        </app-input>

        <button type="button" (click)="openResetForm($event)" mat-button>{{'LOGIN.forgotPasswordBtn' |translate}}</button>
        <button type="submit" mat-raised-button color="accent" [disabled]="loginForm.disabled">{{'LOGIN.loginBtn' |translate}}</button>

        <div class="error" *ngIf="loginError.length != ''">{{'LOGIN.ERROR.'+ loginError | translate}}</div>
      </form>
    </div>

    <div [@tab] *ngIf="resetFormIsOpen">

      <form class="pw-reset-container" [formGroup]="resetForm" (ngSubmit)="resetPW($event)">
        <app-introtext>
          <h1>{{'LOGIN.RESET.header' |translate}}</h1>
          <p>{{'LOGIN.RESET.subheader' |translate}}<br/>
            {{'LOGIN.RESET.subheader2' |translate}}
          </p>
        </app-introtext>

        <app-input>
          {{'LOGIN.RESET.labelEmail' |translate}}
          <input #inputEmail type="email" [formControlName]="'email'" placeholder="{{'LOGIN.placeholderEmail' |translate}}">
        </app-input>

        <button type="button" (click)="closeResetForm($event)" mat-button>{{'LOGIN.RESET.cancelBtn' |translate}}</button>
        <button type="submit" mat-raised-button color="accent" [disabled]="!resetForm.valid || resetForm.disabled">{{'LOGIN.RESET.triggerResetBtn' |translate}}</button>

      </form>
      <div class="reset-request-successful" *ngIf="resetRequestSuccessful">{{'LOGIN.RESET.requestSuccessful' |translate }}</div>
      <div class="error" *ngIf="resetError.length != ''">{{'LOGIN.ERROR.' + resetError | translate}}</div>
    </div>


  </app-module>
</div>

<app-footer></app-footer>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/login/login.component.html